import { useSimpleFormIteratorItem } from "react-admin";
import { useWatch } from "react-hook-form";
import ProfessorInput from "server/components/Fields/ProfessorInput";

const ProfessorsIteratorItem = () => {
  const { index } = useSimpleFormIteratorItem();
  const professors = useWatch({ name: "professors" });
  const departmentId = useWatch({ name: "departmentId" });

  const excludeIds = professors
    ?.filter((_, i) => i !== index)
    ?.map(row => row?.professorEmployeeId)
    ?.filter(Boolean);

  return (
    <ProfessorInput
      source="professorEmployeeId"
      label="Преподавател"
      fullWidth
      filters={{
        ...(excludeIds?.length ? { ExcludeIds: excludeIds } : {}),
        ...(departmentId ? { DepartmentId: departmentId } : {}),
      }}
    />
  );
};

export default ProfessorsIteratorItem;
